export default {
  addresses: '收获地址',
  ads: '广告',
  articles: '文章',
  carts: '购物车',
  categories: '分类',
  collections: '收藏',
  comments: '评价',
  coupons: '优惠券',
  files: '文件',
  footprints: '脚印',
  helpers: '帮助',
  logs: '日志',
  managers: '管理员',
  orders: '订单',
  products: '商品',
  rbacResources: 'RBAC 资源',
  rbacRoles: 'RBAC 角色',
  settings: '设置',
  wxUsers: '微信用户'
}
